<template>
  <div class="hst-footer">
    <div class="g-wrap">
      <div class="box left">
        <h4>友情链接</h4>
        <div class="list-link">
          <p v-for="(item, i) in linkList" :key="i">
            <a @click="handleGo(item)" target="_blank">{{ item.Name }}</a>
          </p>
        </div>
      </div>
      <div class="box right">
        <h4>联系方式</h4>
        <p>电话：{{ (collegeData && collegeData.college.Phone) || "---" }}</p>
        <p>邮箱：{{ (collegeData && collegeData.college.Email) || "---" }}</p>
        <p>地址：{{ (collegeData && collegeData.college.Address) || "---" }}</p>
      </div>
    </div>
    <div class="g-wrap">
      <ic-footer></ic-footer>
    </div>
  </div>
</template>

<script>
import Footer from "_c/Footer";
import { getData } from "api/app";
import { mapState } from "vuex";
export default {
  name: "feature-footer",
  data() {
    return {
      linkList: []
    };
  },
  components: {
    [Footer.name]: Footer
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  methods: {
    loadData() {
      getData({ name: "College" }).then(res => {
        this.linkList = res || [];
      });
    },
    init() {
      this.loadData();
      console.log(this.collegeData);
    },
    handleGo(data) {
      let url = data.PortalLink;
      // let baseUrl = window.location.origin;
      // let url = `${baseUrl}${data.PortalLink}?cid=${data.Id}`;
      window.open(url, "_blank");
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.hst-footer {
  min-width: 1300px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: url(~assets/img/feature/ft.png) no-repeat left top;
  background-size: 100% 100%;
  height: 230px;
  color: #fff;
  .g-wrap {
    justify-content: space-between;
    display: flex;
  }
  .box {
    padding-top: 24px;
    h4 {
      line-height: 22px;
      font-weight: 500;
      font-size: 15px;
      padding-bottom: 10px;
    }
    p {
      line-height: 27px;
      font-size: 13px;
      a {
        color: #fff;
        cursor: pointer;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
  .list-link {
    display: flex;
    width: 800px;
    flex-wrap: wrap;
    height: 80px;
    p {
      width: 200px;
      @include ellipsis();
    }
  }
  ::v-deep .comp-footer {
    width: 100%;
    padding-top: 23px;
    border-top: 1px solid #2a2e41;
    margin-top: 24px;
    position: relative;
    &::before {
      height: 1px;
      content: ' ';
      width: 100%;
      background-color: #6674b8;
      position: absolute;
      top: 0px;
    }
  }
}
</style>
